import arrow_up from "../../images/arrow_up.svg"
import avatar_contact from "../../images/avatar_contact.svg"
import "./FloatButton.css"
const FloatButton = ({ title, onclick }) => {
    return (<div className="floatbutton-card" onClick={() => { document.getElementById("popupGestorTrigger").click(); }}>
        <img className="floatbutton-card-img-mobile" src={avatar_contact} />
        <span className="floatbutton-title">{title}</span>
    </div>);
}

export default FloatButton